module.exports = __webpack_public_path__ + "static/akame_waterfall-751e47d633e0533c713525b638215769.jpg";